import project1 from "../../Images/project-1.png"
import project2 from "../../Images/project-2.png"
import project3 from "../../Images/project-3.png"
import project4 from "../../Images/project-4.png"
import project5 from "../../Images/project-5.png"
import project6 from "../../Images/project-6.png"
import project7 from "../../Images/project-7.png"
import project8 from "../../Images/project-8.png"
import project9 from "../../Images/project-9.png"



export const ProjectData = [
    {
        id : 1,
        name : "Solar",
        title : "Solar Roof",
        img : project1
    },
    {
        id : 2,
        name : "Energy",
        title : "Global Expertise",
        img : project2
    },
    {
        id : 3,
        name : "GeoThermal",
        title : "Poly Crystalline Power",
        img : project3
    },
    {
        id : 4,
        name : "GeoThermal",
        title : "Hybrid Project",
        img : project4
    },
    {
        id : 5,
        name : "GeoThermal",
        title : "Mono Crystalline Shapes",
        img : project5
    },
    {
        id : 6,
        name : "Solar",
        title : "Darrieus Wind Turbine",
        img : project6
    },
    {
        id : 7,
        name : "Solar Wind",
        title : "Wind Turbine",
        img : project7
    },
    {
        id : 8,
        name : "GeoThermal",
        title : "Mono Crystalline Shapes",
        img : project8
    },
    {
        id : 9,
        name : "Solar",
        title : "Darrieus Wind Turbine",
        img : project9
    }

]